import * as React from "react";
import { ChatMicroBtn } from "./ui/ChatMicroBtn";
import { IconClose } from "./icons/ChatIcons";

export type ChatSelectedTextStripProps = {
  text: string;
  onClear: () => void;
};

export const ChatSelectedTextStrip: React.FC<ChatSelectedTextStripProps> = ({ text, onClear }) => {
  const display = text.length > 400 ? `${text.slice(0, 400)}…` : text;
  return (
    <div className="chat-selected-strip">
      <div className="chat-selected-strip__header">
        <p className="chat-selected-strip__label">Selected text</p>
        <ChatMicroBtn title="Clear selected text" aria-label="Clear selected text" onClick={onClear}>
          <IconClose size={12} />
        </ChatMicroBtn>
      </div>
      <div className="chat-selected-strip__body">{display}</div>
    </div>
  );
};
